import google from "../../assets/free-google-1772223-1507807.webp";
import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Divider,
  CircularProgress,
  Button,
} from "@mui/material";
import { Link } from "react-router-dom";
import Logo from "../../components/Logo";
import { externalLogin } from "../../services/auth";
import { useNavigate } from "react-router-dom";
import { getUserById } from "../../services/user";
import { useGoogleLogin } from "@react-oauth/google";
import { getInvitationById } from "../../services/invitation";
import InvalidInvitation from "./InvalidInvitation";
import RegisterForm from "../../components/RegisterForm";
import LoginForm from "../../components/LoginForm";

const Invitation = () => {
  const [isGoogleLoading, setIsGoogleLoading] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [invitationData, setInvitationData] = useState(null);
  const [isPageLoading, setIsPageLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    setIsPageLoading(true);
    const url = new URL(window.location.href);
    const id = url.searchParams.get("id");

    if (id) {
      getInvitationById(id)
        .then((response) => {
          if (!response.message) {
            setInvitationData(response);
          }
          setIsPageLoading(false);
        })
        .catch((error) => {
          console.error("Error obteniendo la invitación:", error);
          navigate("/");
          setIsPageLoading(false);
        });
    } else {
      navigate("/");
      setIsPageLoading(false);
    }
  }, []);

  const googleLogin = useGoogleLogin({
    onSuccess: (codeResponse) => {
      externalGoogleLogin(codeResponse);
    },
    onError: (error) => console.log("Login Failed:", error),
  });

  const externalGoogleLogin = async (codeResponse) => {
    try {
      setIsGoogleLoading(true);
      const userInfo = {
        companyId: invitationData.companyId,
        accessToken: codeResponse.access_token,
      };

      const response = await externalLogin("google", userInfo);

      const userProfile = await getUserById(response.userId);

      navigateToProfile(userProfile);
    } catch (error) {
      //console.error("Error logging in:", error);
      setIsGoogleLoading(false);
      return null;
    }
    setIsGoogleLoading(false);
  };

  const navigateToProfile = (profile) => {
    if (!profile) {
      return;
    }
    if (profile.company) {
      navigate("/home-page", {
        state: { profile: profile },
      });
    } else {
      navigate("/form-workspace", {
        state: { profile: profile },
      });
    }
  };

  return (
    <Container
      maxWidth="lg"
      style={{ textAlign: "center", minHeight: "100vh" }}
    >
      {isPageLoading ? (
        <CircularProgress />
      ) : invitationData?.companyId ? (
        <>
          <Logo
            height={100}
            width={100}
            style={{ marginBottom: "16px", marginTop: "16px" }}
          />

          <Typography variant="h4" gutterBottom>
            <b>{invitationData?.invitedBy}</b> te invita a unirte al workspace{" "}
            <b>{invitationData?.companyName}</b>
          </Typography>
          <Container maxWidth="sm">
            {!showLogin ? (
              <>
                <Typography
                  variant="body2"
                  gutterBottom
                  style={{ marginBottom: "16px", marginTop: "16px" }}
                >
                  ¿Ya tienes una cuenta?{" "}
                  <Link onClick={() => setShowLogin(true)}>
                    Inicia sesión aquí
                  </Link>
                </Typography>
                <RegisterForm
                  companyId={invitationData.companyId}
                  email={invitationData.email}
                />
              </>
            ) : (
              <>
                <Typography
                  variant="body2"
                  gutterBottom
                  style={{ marginBottom: "16px", marginTop: "16px" }}
                >
                  ¿No tienes una cuenta?{" "}
                  <Link onClick={() => setShowLogin(false)}>
                    Registrate aquí
                  </Link>
                </Typography>
                <LoginForm
                  email={invitationData.email}
                  companyId={invitationData.companyId}
                />
              </>
            )}

            <Divider style={{ margin: "16px 0" }} />

            <Button
              variant="contained"
              color="primary"
              fullWidth
              style={{ marginTop: "8px", backgroundColor: "transparent" }}
              onClick={() => googleLogin()}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                {isGoogleLoading ? (
                  <CircularProgress />
                ) : (
                  <>
                    <img
                      src={google}
                      height={"20px"}
                      style={{ marginRight: "8px" }}
                      alt="google"
                    />
                    <span>Continuar con Google</span>
                  </>
                )}
              </div>
            </Button>
          </Container>
        </>
      ) : (
        <InvalidInvitation />
      )}
    </Container>
  );
};

export default Invitation;
